<div class="edit-client">
  <rn-breadcrumbs [links]="links"> </rn-breadcrumbs>
  <router-outlet></router-outlet>

</div>

<message-dialog></message-dialog>
